"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { Moon, Sun } from "lucide-react";
import * as Switch from "@radix-ui/react-switch";
import { cn } from "@/lib/utils";
import React from "react";

const AtlasThemeToggle: React.FC = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const pathname = usePathname();
  const isAtlasPage = pathname.startsWith("/atlas");

  useEffect(() => {
    if (!isAtlasPage) return;
    const saved = localStorage.getItem("atlas-theme");
    const dark = saved === "dark";
    setIsDarkMode(dark);
    applyTheme(dark);
  }, [isAtlasPage]);

  const applyTheme = (dark: boolean) => {
    const htmlEl = document.documentElement;
    if (dark) {
      htmlEl.classList.add("dark");
    } else {
      htmlEl.classList.remove("dark");
    }
  };

  const toggleTheme = (checked: boolean) => {
    setIsDarkMode(checked);
    localStorage.setItem("atlas-theme", checked ? "dark" : "light");
    applyTheme(checked);
  };

  if (!isAtlasPage) return null;

  return (
    <div className="theme-toggle flex items-center space-x-2">
      <Sun className="h-4 w-4 text-gray-500 dark:text-white" />
      <Switch.Root
        className={cn(
          "relative h-[24px] w-[44px] cursor-pointer rounded-full bg-gray-300 outline-none data-[state=checked]:bg-primary",
          "dark:bg-gray-700 dark:data-[state=checked]:bg-primary"
        )}
        checked={isDarkMode}
        onCheckedChange={toggleTheme}
      >
        <Switch.Thumb
          className="block h-[20px] w-[20px] translate-x-[2px] rounded-full bg-white transition-transform duration-100 will-change-transform data-[state=checked]:translate-x-[22px]"
        />
      </Switch.Root>
      <Moon className="h-4 w-4 text-gray-500 dark:text-white" />
    </div>
  );
};

export default AtlasThemeToggle;
